import module from 'contabilidad/catalogosexternos/module'
import template from './template.html'

export class SucursalesListaComponent {
  data

  constructor(CatalogosExternosSucursales) {
    this.CatalogosExternosSucursalesService = CatalogosExternosSucursales
  }

  $onInit() {
    this.promise = this.CatalogosExternosSucursalesService.get()
      .then((resolve) => {
        this.data = resolve.data
      })
  }
}

module.component('contabilidadCatalogosexternosSucursalesLista', {
  controller: SucursalesListaComponent,
  template: template,
})



// WEBPACK FOOTER //
// ./src/contabilidad/catalogosexternos/components/sucursales/lista/component.js